import { useQuery } from "react-query";
import { getAllActions } from "client-api-workflow";

export interface ActionData {
	_id?: string;
	id?: string;
	actionName: string;
	description: string;
	assignTo: string[];
	assignToNames: string[];
	searchKpiInitiativeId: string | null;
	searchKpiInitiativeName: string | null;
	searchKpiInitiativeType: string | null;
	status: string;
	createdAt?: string;
	updatedAt?: string;
	createdBy?: string;
	tenantId?: string;
	deadline?: string;
	scorecard?: string;
}

const useAllActions = () => {
	return useQuery<ActionData[], Error>(
		"actions",
		async () => {
			return getAllActions();
		},

		{
			staleTime: 30000, // 30 seconds cache
			refetchOnWindowFocus: false,
			retry: 1,
			onError: (error) => {
				console.error("Error fetching actions:", error);
			}
		}
	);
};

export default useAllActions;

